<div class="landing-page-container min-h-screen bg-[#fafafa] text-slate-900 overflow-x-hidden"
  style="font-family: 'Inter', sans-serif;">
  <app-navbar></app-navbar>
  <app-hero></app-hero>
  <app-logo-marquee></app-logo-marquee>
  <app-featured-jobs></app-featured-jobs>
  <app-featured-mock-test></app-featured-mock-test>
  <!-- <app-featured-mock-interview></app-featured-mock-interview> -->
  <app-mock-interviews></app-mock-interviews> 
  <!-- <app-assessments></app-assessments> not using now -->
  <app-why-choose></app-why-choose>
  <app-journey-timeline></app-journey-timeline>
  <app-testimonials></app-testimonials>
  <app-stats></app-stats>
  <app-resume-builder></app-resume-builder>
  <app-career-roadmap></app-career-roadmap>
  <app-whats-app-community></app-whats-app-community>
  <app-final-c-t-a></app-final-c-t-a>
  <app-footer></app-footer>
  <app-floating-whatsapp></app-floating-whatsapp>
</div>